module.exports = __webpack_public_path__ + "7129b8cee07aae3ac743b38e5a3165db.svg";